/**
 * 自动降级钩子 :: 在 Canvas 内运行，每帧把 fps 喂入 perf.ts 的状态机，
 * 当连续低于阈值时下调 quality；自定义稳定后再上调。
 *
 * 仅当 settings.autoDegrade 为 true 且玩家在 in-game scene 时生效。
 */
import { useEffect, useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import { useAppStore } from '@/core/store'
import { initialPerfSample, pushFrame, nextTier, type PerfSample } from './perf'

export function useAutoDegrade() {
  const enabled = useAppStore((s) => s.settings.autoDegrade)
  const tier = useAppStore((s) => s.settings.quality)
  const updateSettings = useAppStore((s) => s.updateSettings)

  const sampleRef = useRef<PerfSample>({ ...initialPerfSample })

  // 切场景 / 切档位 / 关闭开关时 -> 重置采样
  useEffect(() => {
    sampleRef.current = { ...initialPerfSample }
  }, [enabled, tier])

  useFrame((_state, delta) => {
    if (!enabled || delta <= 0) return
    const fps = 1 / delta
    const { sample, change } = pushFrame(sampleRef.current, fps, tier)
    sampleRef.current = sample
    if (change !== 'none') {
      const newTier = nextTier(tier, change)
      if (newTier !== tier) {
        updateSettings({ quality: newTier })
      }
    }
  })
}
